import {
  LocationFilterOptionKey,
  LocationFinderContextProps,
  MarkerFilterFn,
} from "./types";

import { BRAND_BOOK_COLORS } from "~/Constant/Theme/configs/equipmentshare";
import { Paths } from "~/OmnichannelApi/openapi";

// https://console.cloud.google.com/google/maps-apis/studio/maps/d3546adb37a820a5?project=omnichannel-401906
export const MAP_ID = "d3546adb37a820a5";

export const MARKER_COLOR_DEFAULT: string = BRAND_BOOK_COLORS.BLACK_6C;
export const MARKER_COLOR_ACTIVE: string = BRAND_BOOK_COLORS.ORANGE_PRIMARY;

export const LOCATION_FINDER_MAP_RESTRICTION: google.maps.MapRestriction = {
  latLngBounds: {
    west: -150,
    east: -40,
    north: 60,
    south: 10,
  },
};

export const LOCATION_FINDER_MAP_CENTER: google.maps.LatLngLiteral = {
  lat: 39.8313,
  lng: -98.578,
};

const PLACEHOLDER_FN = () => {
  return;
};

export const LOCATION_FILTER_OPTIONS: Array<{
  key: LocationFilterOptionKey;
  label: string;
  isVisible: (
    locationData: Paths.LocationFinderSearch.Responses.$200 | undefined
  ) => boolean;

  filterFn: MarkerFilterFn;
}> = [
  {
    key: "all",
    label: "All",
    isVisible: () => true,
    filterFn: () => true,
  },
  {
    key: "core",
    label: "Core",
    isVisible: (locationData) =>
      Boolean(
        locationData?.aggs["location.markets.solution.slug"]?.buckets?.some(
          (b) => b.key === "core"
        )
      ),
    filterFn: (loc) =>
      loc.markets.some((m) => m.solution.name === "Core Solutions"),
  },
  {
    key: "advanced",
    label: "Advanced",
    isVisible: (locationData) =>
      Boolean(
        locationData?.aggs["location.markets.solution.slug"]?.buckets?.some(
          (b) => b.key === "advanced"
        )
      ),
    filterFn: (loc) =>
      loc.markets.some((m) => m.solution.name === "Advanced Solutions"),
  },
  {
    key: "tooling",
    label: "Tooling",
    isVisible: (locationData) =>
      Boolean(
        locationData?.aggs["location.markets.solution.slug"]?.buckets?.some(
          (b) => b.key === "tooling"
        )
      ),
    filterFn: (loc) =>
      loc.markets.some((m) => m.solution.name === "Tooling Solutions"),
  },
  {
    key: "forge-build",
    label: "Forge & Build",
    isVisible: (locationData) =>
      Boolean(
        locationData?.aggs["location.markets.solution.slug"]?.buckets?.some(
          (b) => b.key === "forge-build"
        )
      ),
    filterFn: (loc) =>
      loc.markets.some((m) => m.solution.name === "Forge & Build"),
  },
  {
    key: "dealership",
    label: "Dealership",
    isVisible: () => true,
    filterFn: (loc) =>
      loc.markets.some((m) =>
        m.rental_services?.some((r) =>
          [
            "link-belt",
            "thunder-creek",
            "epiroc-hydraulic-attachments",
            "epiroc-drills",
            "sennebogen",
            "takeuchi",
            "mecalac",
            "robbak",
            "yanmar",
            "develon",
          ].includes(r.slug)
        )
      ),
  },
] as const;

export const LOCATION_FINDER_CONTEXT_DEFAULT: LocationFinderContextProps = {
  userGeo: undefined,
  locationData: undefined,
  locationSpecialHours: undefined,
  setLocationSearchOptions: PLACEHOLDER_FN,
  mapsLib: undefined,
  markerLib: undefined,
  setMountedMap: PLACEHOLDER_FN,
  markerClusterer: undefined,
  setMarkerClusterer: PLACEHOLDER_FN,
  activeMarkerSlug: undefined,
  setActiveMarkerSlug: PLACEHOLDER_FN,
  panMapTo: PLACEHOLDER_FN,
  distanceCenter: LOCATION_FINDER_MAP_CENTER,
  setDistanceCenter: PLACEHOLDER_FN,
  isDrawerOpen: true,
  setIsDrawerOpen: PLACEHOLDER_FN,
  activeFilterTypeValue: "",
  setActiveFilterTypeValue: PLACEHOLDER_FN,
};
